import Vue from 'vue';
import VueCodemirror from 'vue-codemirror';
import 'codemirror/mode/javascript/javascript.js';
import 'codemirror/mode/vue/vue.js';

import 'codemirror/theme/base16-light.css';

import 'codemirror/addon/selection/active-line.js';
import 'codemirror/addon/selection/mark-selection.js';
import 'codemirror/addon/search/searchcursor.js';

import 'codemirror/addon/search/search.js';
import 'codemirror/keymap/sublime.js';

Vue.use(VueCodemirror);
